export default "__VITE_ASSET__GpHiRR4F__"